import { AdvertisersSection } from '@features/users/adminPanel/containers/AdvertisersSection/AdvertisersSection.tsx';
import { BillingInfoSection } from '@features/users/adminPanel/containers/BillingInfoSection/BillingInfoSection.tsx';
import { useUserProfileData } from '@shared/hooks/useUserProfileData.ts';
import { useUserDetails } from '@shared/providers/UserDetailsProvider/useUserDetails.tsx';

import styles from './AdminPanelPage.module.scss';

export default function AdminPanelPage() {
  const { isExternalDirectClient, isExternalAgency } = useUserDetails();
  const isExternal = isExternalDirectClient || isExternalAgency;

  const { isUserProfileDataApproved, userProfileDataIsFetched } = useUserProfileData({
    canFetchUserProfileData: isExternal,
  });

  const canFetchAdvertisers = isUserProfileDataApproved && userProfileDataIsFetched;

  return (
    <div className={styles.wrapper}>
      <div className={styles.innerWrapper}>
        <section className='content-wrapper'>
          {isExternalDirectClient && (
            <div className='grid'>
              <div className='row'>
                <div className='col-12'>
                  <BillingInfoSection />
                </div>
              </div>
            </div>
          )}
          {isExternalAgency && (
            <div className='grid'>
              <div className='row'>
                <div className='col-4'>
                  <BillingInfoSection />
                </div>
                <div className='col-8'>
                  <AdvertisersSection
                    canFetchAdvertisers={canFetchAdvertisers}
                    isUserDataFetched={userProfileDataIsFetched}
                  />
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
